module.exports = __webpack_public_path__ + "img/c00_buildingtechhandcart_Normal_ua.1e45c95b.webp";